import { Company } from './Company'

export class UserAdmin {
	public _id: string = ''
	public name: string = ''
	public cpf: string = ''
	public email: string = ''
	public tel: string = ''
	public crea?: string = ''
	public status: string = ''
	public companies: Array<Company> = []
	public media_url: string = ''
	public roles: Array<string> = []
	public jobTitle: string = ''
	public jobFunction: string = ''
	public blocked: boolean = false
	public assignments: Array<string> = []
	public subModules: Array<string> = []
	public companyServiceProviderId: number = 0
}
